import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ACTOR_TAGS, FILMS, REGIONS } from "@/mocks/films";
import FilmCard from "@/components/feature/FilmCard";

const QUICK_TAGS = ["剧情", "爱情", "悬疑", "文艺", "剧集", "2026 新片"];

export default function EditorPicks() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const picks = FILMS.filter((film) => film.rating >= 8.2).slice(0, 8);

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="rounded-lg bg-accent-50 border border-accent-200 p-5 md:p-8">
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-5 items-center">
              <div>
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  想更准确地找到某一部影片？
                </h2>
                <p className="mt-1.5 text-[13px] text-foreground-600">
                  支持按片名、英文片名或演员姓名模糊匹配，输入关键词回车即可检索。
                </p>
              </div>
              <form onSubmit={submit} className="flex items-center gap-2 w-full lg:w-auto">
                <div className="relative flex-1 lg:w-72">
                  <i className="ri-search-2-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" />
                  <input
                    value={keyword}
                    onChange={(event) => setKeyword(event.target.value)}
                    placeholder="输入片名或演员名，如：巴黎"
                    className="w-full h-11 pl-9 pr-3 rounded-md border border-accent-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500"
                  />
                </div>
                <button
                  type="submit"
                  className="h-11 px-5 rounded-md bg-primary-900 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer"
                >
                  搜索
                </button>
              </form>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-[12px] text-foreground-500">热门搜索：</span>
              {QUICK_TAGS.map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag.replace(" 新片", ""))}`}
                  className="px-2.5 py-1 rounded-full bg-background-50 border border-accent-200 text-[12px] text-foreground-700 hover:border-accent-400 hover:text-accent-800 transition-colors cursor-pointer"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-10 md:mt-12 flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
            <div>
              <p className="text-[11px] tracking-[0.3em] uppercase text-accent-700 mb-1.5">
                Editor&apos;s Selection
              </p>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                焦点推荐影片
              </h2>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {REGIONS.slice(0, 4).map((region) => (
                <Link
                  key={region}
                  to={`/category/drama?region=${encodeURIComponent(region)}`}
                  className="px-2.5 py-1 rounded-md bg-background-100 border border-background-200 text-[12px] text-foreground-600 hover:border-accent-300 hover:text-accent-800 transition-colors cursor-pointer"
                >
                  {region}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            {picks.map((film) => (
              <FilmCard key={film.id} film={film} />
            ))}
          </div>

          <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  按演员查找作品
                </h3>
                <p className="mt-1 text-[13px] text-foreground-500">
                  点击演员姓名可查看其参与的全部影片资料，演员页与详情页信息保持一致。
                </p>
              </div>
              <div className="flex flex-wrap gap-2">
                {ACTOR_TAGS.slice(0, 4).map((name) => (
                  <Link
                    key={name}
                    to={`/search?q=${encodeURIComponent(name)}`}
                    className="px-3 py-1.5 rounded-md bg-background-50 border border-background-200 text-[12px] text-foreground-700 hover:border-accent-300 transition-colors cursor-pointer"
                  >
                    <i className="ri-user-line mr-1 text-foreground-400" />
                    {name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}